import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

interface ConsultationChargeParams {
  hospitalId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

const getConsultationCharges = createAsyncThunk(
  'getConsultationCharges',
  async (params: ConsultationChargeParams = {}) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = params.hospitalId || sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const query = new URLSearchParams();
      if (hospitalId) query.append('hospitalId', hospitalId);
      if (params.search) query.append('search', params.search);
      if (params.page !== undefined) query.append('page', String(params.page));
      if (params.limit !== undefined) query.append('limit', String(params.limit));
      const url = `${BILLING_ROUTES.CONSULTATION_CHARGES.get}?${query.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Billing Details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default getConsultationCharges;
